import api from '@services'
import { stripEmptyObjects } from '@utils'

const serviceBaseUrl = process.env.REACT_APP_MRSTA_USER_BASE_URL ?? ''
const servicePrefix = `${serviceBaseUrl}/svc/mrsta-user/api`

const getMrstaUsers = async (params) => {
  const response = await api.get(`${servicePrefix}/users`, { params: stripEmptyObjects(params) })
  return response.data
}

const getMrstaUser = async (id) => {
  const response = await api.get(`${servicePrefix}/users/${id}`)
  return response.data
}

const updateMrstaUser = async (id, user) => {
  // Filter out empty string values for optional fields
  const cleanedUser = {}
  Object.entries(user).forEach(([key, value]) => {
    if (value !== "") {
      cleanedUser[key] = value
    }
  })
  const response = await api.patch(`${servicePrefix}/users/${id}`, cleanedUser)
  return response.data
}

const changeMrstaUserPassword = async (id, newPin) => {
  const response = await api.patch(`${servicePrefix}/users/${id}/change-password`, { newPin })
  return response.data
}

const searchMrstaUser = async (searchTerm) => {
  // Try to determine if searchTerm is CID or mobile number
  const isNumeric = /^\d+$/.test(searchTerm.replace(/\+/, ''))
  const isCID = isNumeric && searchTerm.length >= 10 && !searchTerm.startsWith('+')
  const isMobile = isNumeric && (searchTerm.startsWith('+975') || searchTerm.length === 8)
  
  let queryParam = ''
  if (isCID) {
    queryParam = `cid=${searchTerm}`
  } else if (isMobile) {
    queryParam = `mobileNo=${searchTerm}`
  } else {
    // Default to CID search
    queryParam = `cid=${searchTerm}`
  }
  
  const response = await api.get(`${servicePrefix}/users/search?${queryParam}`)
  return response.data
}

const MrstaUserService = {
  getMrstaUsers,
  getMrstaUser,
  updateMrstaUser,
  changeMrstaUserPassword,
  searchMrstaUser
}

export default MrstaUserService
